import React from 'react';
import styles from './NavbarContained.module.css';
import logo from '../../assets/logo/logo-main.png';
import { Link, useNavigate } from 'react-router-dom';
import { UniversalContext } from "../../context/UniversalContext/UniversalContext";
import AppointmentModal from "../Modal/AppointmentModal/AppointmentModal";
import AboutUsForm from "../Modal/AboutUsForm/AboutUsForm";
import ProfessionalRegistrationForm from "../Modal/ProfessionalRegistrationModal/ProfessionalRegistrationModal";
import ContactUsForm from '../Modal/ContactUsForm/ContactUsForm';
import Hamburger from '../Hamburger/Hamburger';

const NavbarContained = () => {
  const { contactUsModal, setContactUsModal, aboutUsModal, setAboutUsModal, professionalModal, setProfessionalModal } = React.useContext(UniversalContext); 
  const navigate = useNavigate();
  return (
    <div className={styles.navCont}>
      <div>
        <Link to='/'><img src={logo} alt="Logo" /></Link>
      </div>
      <div>
        <ul className={styles.Ham}>
          <Hamburger />
        </ul>
        <ul className={styles.ulist}>
          <li onClick={() => setProfessionalModal(true)}>
            Register As A Professional
          </li>
          <li onClick={() => navigate('/')}>Home</li>
          <li onClick={() => navigate('/about')}>About Us</li>
          <li onClick={() => navigate('/contact')}>Contact Us</li>
        </ul>
      </div>
      {professionalModal && <ProfessionalRegistrationForm />}
      {aboutUsModal && <AboutUsForm />}
      {contactUsModal && <ContactUsForm />}
    </div>
  );
}

export default NavbarContained;